import { Headline2, Paragraph } from '@cdm/quickenloans-library/lib';
import { Link } from "gatsby";
import PropTypes from 'prop-types';
import React, { useMemo, useState } from "react";
import buildSpecs from '../../../context/build/Constants.json';
import genAbsoluteUrl from '../../../utilities/genAbsoluteUrl';
import Pagination from "../../Atoms/Pagination";
import PostGrid from '../PostGrid/index';
import { defaultTitle, testAttributes } from './Constants';
import { lcGridContainer, lcGridContainerContent, lcGridContainerTitle, lcGridContainerTitleActions, lcGridContainerTitleText } from './LearningCenterGridContainer.module.scss';

const LearningCenterGridContainer = (props) =>
{
    const {title = defaultTitle, slug = "#", articleListProps, pageContext, isContractedVariation = false} = props;
    const { queryArgs, gridLimit, handlePageChange } = articleListProps;
    const pageIndex = articleListProps?.currentPage ? articleListProps.currentPage - 1 : 0;
    const totalPosts = pageContext?.totalPosts;
    const totalPages = pageContext?.totalPages || 0;

    const postsPerPage = buildSpecs.BUILD.defaults.POSTS_PER_PAGE;
    const startPost = (articleListProps.currentPage - 1) * postsPerPage + 1;
    const endPost = Math.min(articleListProps.currentPage * postsPerPage, totalPosts);
    
    const setViewLimit = (pageSelected) =>  gridLimit * (pageSelected+1);
    const defaultViewLabel = `${startPost}*${endPost}*${totalPosts}`;
    const [availableViewPostsLabel, setAvailableViewPostsLabel] = useState(defaultViewLabel);
    
    const handlePageCounter = (event) => 
    {
        const viewLimit = setViewLimit(event.selected);
        return setAvailableViewPostsLabel(`${viewLimit-gridLimit+1}*${(viewLimit-gridLimit)}*${totalPosts}`);
    };

    const articleCount = useMemo(() =>
    {
        const [currentStart, currentEnd, total] = availableViewPostsLabel.split('*');
        return {
            current: `Displaying ${currentStart} - ${currentEnd}`,
            total: isContractedVariation ? `${total} Articles` : ` of ${total}`
        };
    }, [availableViewPostsLabel]);

    const showGridTitle = useMemo(() => (/^\/[^\/]+(?:\/[^\/]+)?\/?$/).test(pageContext?.uri), [pageContext?.uri]);

    const gridTitle = useMemo(() =>
    {
        if (!showGridTitle) return null;

        const titleContent = (
            <Headline2
                id="learning-center-category-grid-title"
                className='h3_semi_bold_newSize'
                testId={testAttributes.LC_ARTICLE_GRID_TITLE}
            >
                {title}
            </Headline2>
        );

        return isContractedVariation ?
            <Link to={slug}>
                {titleContent}
            </Link>
            : titleContent;
    }, [title]);
    
    return(
        (totalPosts > 0) && <div data-testid={testAttributes.LC_ARTICLE_GRID_CONTAINER} className={lcGridContainer}>
            {queryArgs?.posts.length > 0 && totalPages >= 1 && (
                <>
                    <div className={lcGridContainerTitle}>
                        <div className={lcGridContainerTitleText} >
                            {gridTitle}
                            <Paragraph>
                                {!isContractedVariation ? articleCount.current : null}
                                <span>
                                    {articleCount.total}
                                </span>
                            </Paragraph>
                        </div>
                        {
                            isContractedVariation && <div className={lcGridContainerTitleActions}>
                                <Link to={slug}>Display All</Link>
                            </div>
                        }
                    </div>
                    <PostGrid
                        posts={queryArgs?.posts}
                        postLimit={gridLimit}
                        className={isContractedVariation ? lcGridContainerContent : undefined}
                    />
                </>
            )}
            {!isContractedVariation && totalPages > 1 && <Pagination
                breakLabel="..."
                pageCount={totalPages}
                handleClick={(event)=> 
                {
                    handlePageChange(event.selected); handlePageCounter(event)
                }}
                defaultPage={pageIndex}
                hrefBuilder={(page) => {
                    const path = `${pageContext?.uri || ''}/page/${page}`;
                    return page >= 1 && page <= totalPages ? genAbsoluteUrl(path) : ''
                }}
            />}
        </div>
        
    )
};

LearningCenterGridContainer.propTypes = {
    /** Title of the grid container */
    title: PropTypes.string,
    slug: PropTypes.string,
    /** Container props typeof object {queryArgs, gridLimit, handlePageChange, showControl} */
    articleListProps: PropTypes.object.isRequired,
    pageContext: PropTypes.object,
    isContractedVariation: PropTypes.bool,
};

export default LearningCenterGridContainer;